<div class="container" *ngIf="csv">
  <div class="row">
    <div class="col-md-12">
      <textarea #csvField rows="30" cols="200" (keyup)="changed.emit()" [disabled]="loading || saving">{{ csv }}</textarea>
    </div>
  </div>
  <div class="" row>
    {{ errorMessage }}
  </div>
  <div class="row">
    <div class="col-md-6">
      <eps-button buttonIcon="save" label="ADMIN.I18N.BUTTONS.SAVE" (buttonClick)="save.emit(csvField.value)" [disabled]="!loading && !enableSave" [busy]="saving"></eps-button>
    </div>
  </div>
</div>
